module.exports = __webpack_public_path__ + "img/9.d72d3992.jpg";